var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusPrimaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8778_199365)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.14453,
    y: 2,
    width: 29.2435,
    height: 29,
    rx: 4,
    fill: "#128B9B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8778_199365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0592 19.6468V17.1924H14.5842C14.1936 17.1924 13.8771 16.8785 13.8771 16.4911C13.8771 16.1039 14.1936 15.7899 14.5842 15.7899H17.0592V13.3354C17.0592 12.9482 17.3758 12.6342 17.7664 12.6342C18.157 12.6342 18.4735 12.9482 18.4735 13.3354V15.7899H20.9486C21.3392 15.7899 21.6557 16.1039 21.6557 16.4911C21.6557 16.8785 21.3392 17.1924 20.9486 17.1924H18.4735V19.6468C18.4735 20.0342 18.157 20.3481 17.7664 20.3481C17.3758 20.3481 17.0592 20.0342 17.0592 19.6468ZM24.1668 10.1447C22.4572 8.44932 20.1841 7.51562 17.7664 7.51562C15.3487 7.51562 13.0756 8.44932 11.366 10.1447C9.65638 11.84 8.71484 14.0942 8.71484 16.4918C8.71484 18.8894 9.65638 21.1436 11.366 22.8389C13.0756 24.5343 15.3487 25.468 17.7664 25.468C19.4216 25.468 21.0411 25.0207 22.4499 24.1744C22.784 23.9737 22.8908 23.5425 22.6884 23.2114C22.4861 22.88 22.0512 22.7742 21.7172 22.9748C20.5294 23.6883 19.1632 24.0655 17.7664 24.0655C13.5552 24.0655 10.1291 20.6679 10.1291 16.4918C10.1291 12.3157 13.5552 8.91815 17.7664 8.91815C21.9775 8.91815 25.4036 12.3157 25.4036 16.4918C25.4036 17.9852 24.9559 19.4386 24.1087 20.6954C23.8915 21.0173 23.9788 21.4529 24.3035 21.6682C24.6281 21.8833 25.0673 21.7968 25.2844 21.4749C26.2876 19.9868 26.8179 18.2636 26.8179 16.4918C26.8179 14.0942 25.8764 11.84 24.1668 10.1447Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8778_199365",
    x: 0.144531,
    y: 0,
    width: 37.2441,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8778_199365"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8778_199365",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8778_199365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1031,
    height: 17.9524,
    fill: "white",
    transform: "translate(8.71484 7.51562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPrimaryIcon);
export default __webpack_public_path__ + "static/media/plus-primary-icon.0d8af238244be8bd013ad0a26c3ed4f5.svg";
export { ForwardRef as ReactComponent };